import actionTypes from '../actions';
const initialState = {
    stateCodes: [],
    countryCodes: []
}

const commonReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.FETCHSTATES:
            state = {
                ...state,
                stateCodes: payload
            }
            break;
        case actionTypes.FETCHCOUNTRY:
            state = {
                ...state,
                countryCodes: payload
            }
            break;
        default: return state;

    }
    return state
}

export default commonReducer
